/**
 * @generated SignedSource<<22fb78f4612d1d47650e0b18dc54fac2>>
 * @relayHash 560e1a649779a02d480449d3db375a0f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 560e1a649779a02d480449d3db375a0f

import { ConcreteRequest } from 'relay-runtime';
export type TopIndependentStatus = "DISCOVERED" | "OPTED_IN" | "OPTED_OUT" | "UNDISCOVERED" | "%future added value";
export type AdminRateUserProfileInput = {
  basicScore?: number | null;
  bonusScore?: number | null;
  excludeFromDiscover?: boolean | null;
  excludeFromMatching?: boolean | null;
  flagForImprovement?: boolean | null;
  hasBeenFeaturedOnSocial?: boolean | null;
  id: string;
  internalNotes?: string | null;
  isTopContractor?: boolean | null;
  projectsScore?: number | null;
  rating?: number | null;
  servicesScore?: number | null;
  socialFeatureEligible?: boolean | null;
  topIndependentStatus?: TopIndependentStatus | null;
};
export type RatingMenuMutation$variables = {
  input: AdminRateUserProfileInput;
};
export type RatingMenuMutation$data = {
  readonly adminRateUserProfile: {
    readonly adminUserSearchResult: {
      readonly id: string;
      readonly rating: {
        readonly excludeFromDiscover: boolean | null;
        readonly excludeFromMatching: boolean | null;
        readonly flagForImprovement: boolean | null;
        readonly id: string;
        readonly internalNotes: string | null;
      } | null;
      readonly userProfile: {
        readonly topIndependentStatus: TopIndependentStatus;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }> | null;
  };
};
export type RatingMenuMutation = {
  response: RatingMenuMutation$data;
  variables: RatingMenuMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topIndependentStatus",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfileRating",
  "kind": "LinkedField",
  "name": "rating",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excludeFromDiscover",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excludeFromMatching",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flagForImprovement",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalNotes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RatingMenuMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminRateUserProfilePayload",
        "kind": "LinkedField",
        "name": "adminRateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUserSearchResult",
            "kind": "LinkedField",
            "name": "adminUserSearchResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "userProfile",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RatingMenuMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminRateUserProfilePayload",
        "kind": "LinkedField",
        "name": "adminRateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUserSearchResult",
            "kind": "LinkedField",
            "name": "adminUserSearchResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "userProfile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "560e1a649779a02d480449d3db375a0f",
    "metadata": {},
    "name": "RatingMenuMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0b998a2db065a11456ea46a5504257f4";

export default node;
